// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1dP5f","rootSuccess":"CompleteLink_rootSuccess__34bAe","rootFailure":"CompleteLink_rootFailure__1nu-P","isDisabled":"CompleteLink_isDisabled__3YfOv"};